/**
 * Product List tab component
 */

var HPELog = require('core/log');

var HPEServices = require('../../base/hpe.services');
var HPEConstants = require('../../base/hpe.constants');

var DynamicTabContainerInterface = require('../dynamictabcontainer/hpe.dynamic.tab.container.interface');
var ProductListTabView = require('./hpe.product.list.tab.view');

module.exports = DynamicTabContainerInterface.extend({

    props: {
        view: 'object',
        xhr: 'object',
        el: 'object',
        shouldDestroy: ['boolean', false, true]
    },

    /**
     * initialization called dynamic tab loader
     * @param {object} options configuration options
     */
    init: function(options) {

        //do not proceed if missing required el param
        if (options && (options.el)) {

            //save reference to passed element
            this.el = options.el;

            //create view
            this.view = new ProductListTabView({
                el: this.el
            });

            //passed required service path from tab container component overrides any other model url values
            if (options.servicePath) {
                this.view.serviceURL = options.servicePath;
            } else {
                HPELog.log('product list missing required service url');
            }

            //ensure tab-level base view is rendered with fresh selector from DOM before
            //loading/rendering children + sub-views
            this.view.el = document.querySelector('#dynamic-tab-container-panel-content');
            this.view.render();

            //required response in case this is the default AEM rendered component on page load
            HPEServices.publish(HPEConstants.dynamictabcontainer.CHILDINIT, {
                child: this,
                htmlTabInstance: false
            });
            return this;

        } else {
            HPELog.error('[Products]: cannot create catalog tab, missing el');
        }
    },

    /**
     * destroy
     * extend to perform additional cleanup, remove events, abort XHR, etc
     */
    destroy: function() {

        //Remove and clean up view
        this.view.catalogInstance.destroy();
        this.view.remove();

        //attempt to stop any XHR not currently complete
        if (this.view.xhr && this.view.xhr.readyState && (this.view.xhr.readyState < 4)) {
            this.view.xhr.abort();
        }
        this.view.xhr = null;
    }
});
